import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useCourseComplete } = getCRUDHooks({
  entityName: 'courseComplete',
  create: ({ userId, courseId }) =>
    clientApi.getOCClient().helpers.learningActivity.courses.markAsComplete(userId, courseId),
});

export default useCourseComplete;
